<template>
    <div class="paas-main">
        <!-- 头部 -->
        <headers></headers>
        <div v-if="langluageType == 'ch'">
            <section class="ban">
                <div class="col">
                        <h1 class="title1" style="text-align: center;">以创新服务赋能展会</h1>
                </div>
            </section>
            <div style="">
                <section class="col" style="padding-top: 150px; padding-bottom: 50px;">
                    <h4 class="title3" style="margin-bottom: 30px;">深入会展的行业资源</h4>
                    <ul class="list5">
                        <li>
                            <img src="../images/img-5.png" alt="">
                            <div>
                                <div>丰富的展陈资源积累</div>
                                <p>拥有全域优质会展供应商库<br>
                                    提供最高效、最便捷、最经济<br>的解决方案。</p>
                            </div>
                        </li>
                        <li>
                            <img src="../images/img-6.png" alt="">
                            <div>
                                <div>良好的政务协调能力</div>
                                <p>与商务主管部门、各级会展行业<br>
                                    协会、全国各地会展主管单位和行业协会<br>
                                    均保持长期良好的沟通协调渠道。</p>
                            </div>
                        </li>
                        <li>
                            <img src="../images/img-7.png" alt="">
                            <div>
                                <div>和谐的场馆合作氛围</div>
                                <p>与北京、上海、天津、重庆、广州、深圳<br>
                                    成都、武汉、南京、长沙、合肥等各地会展场馆<br>
                                    建立了长期高效的合作关系。</p>
                            </div>
                        </li>
                    </ul>
                </section>
                <section class="col" style="padding-top: 50px; padding-bottom: 50px;">
                    <h4 class="title3" style="margin-bottom: 30px;">全流程数字化服务</h4>
                    <div class="">
                        <ul class="list4">
                            <li>
                                <div class="i-title">
                                    <img src="../images/icon-1.svg" alt="">
                                    <span>报馆功能</span>
                                </div>
                                <p>可通过PC端会展云的报馆系统，线上提交报馆资料，会展云提供在线审图服务，助力展商迅速完成报馆流程。</p>
                            </li>
                            <li>
                                <div class="i-title">
                                    <img src="../images/icon-2.svg" alt="">
                                    <span>查询功能</span>
                                </div>
                                <p>可以通过PC端进入报馆系统查询界面，主场云统一分配查询码，便于展会主办方实时了解报馆情况。</p>
                            </li>
                            <li>
                                <div class="i-title">
                                    <img src="../images/icon-3.svg" alt="">
                                    <span>现场下单</span>
                                </div>
                                <p>可以通过移动端小程序直接购买展会现场相关商品，实现无接触式服务，集高效、便捷和快速于一身。</p>
                            </li>
                        </ul>
                    </div>
                </section>
                <section class="col box-3">
                    <h4 class="title3" style="margin-bottom: 50px;">部分服务项目</h4>
                    <ul class="brand-list">
                        <li><img src="../images/brand-1.svg" alt=""></li>
                        <li><img src="../images/brand-2.svg" alt=""></li>
                        <li><img src="../images/brand-3.svg" alt=""></li>
                        <li><img src="../images/brand-4.svg" alt=""></li>
                        <li><img src="../images/brand-5.svg" alt=""></li>
                        <li><img src="../images/brand-6.svg" alt=""></li>
                        <li><img src="../images/brand-7.svg" alt=""></li>
                        <li><img src="../images/brand-8.svg" alt=""></li>
                        <li><img src="../images/brand-9.svg" alt=""></li>
                        <li><img src="../images/brand-10.svg" alt=""></li>
                        <li><img src="../images/brand-11.svg" alt=""></li>
                        <li><img src="../images/brand-12.svg" alt=""></li>
                    </ul>
                </section>

                
            </div>
            <h4 class="title3" style="margin-bottom: 30px;margin-top: 100px;font-size: 34px;">获取主场服务</h4>
            <div class="box-fwlx">
                <section class="col box-3 ">
                    <div class="box-fwlx-con-2">
                        <p>联系人：顾先生</p>
                        <img src="../images/img-kf3.png" alt="">
                        <p>咨询热线</p>
                        <span>010-86460766-805</span>
                    </div>
                </section>
            </div>
        </div>
        <div v-else>
            <section class="ban">
                <div class="col">
                    <h1 class="title1" style="text-align: center;">Empowering exhibitions with innovative services</h1>
                </div>
            </section>
            <div style="">
                <div style="width: 1266px;margin: 0 auto;">
                    <h3 style="text-align: center; font-size: 36px;font-weight: 700;margin-top: 168px;margin-bottom: 42px;">Empowering exhibitions with innovative services</h3>
                    <p style="text-align: center;font-size: 20px;">
                        Over the past 5 years, the company has formed a service system of synchronous development in five places with Beijing as the core, ploughed into more than 20 cities, maintained a good cooperation atmosphere with more than 30 exhibition halls, and provided services for a total of 100 exhibitions.
                    </p>
                </div>
                <section class="col" style="padding-top: 150px; padding-bottom: 50px;">
                    <h4 class="title3" style="margin-bottom: 30px;color: #333333;font-size: 30px;">In-depth convention industry resources</h4>
                    <ul class="list5">
                        <li>
                            <img src="../images/img-5.png" alt="">
                            <div style="text-align: center;box-sizing: border-box;padding: 0 70px;justify-content: unset;padding-top: 110px">
                                <div style="line-height: normal;text-align: center;padding-left: 0;margin-left: 0;">Rich accumulation of exhibition resources</div>
                                <p style="line-height: normal;font-size: 18px;">We have a global high-quality exhibition supplier database to provide the most efficient, convenient and economical solutions.</p>
                            </div>
                        </li>
                        <li>
                            <img src="../images/img-6.png" alt="">
                            <div style="text-align: center;box-sizing: border-box;padding: 0 70px;justify-content: unset;padding-top: 110px">
                                <div style="line-height: normal;text-align: center;padding-left: 0;margin-left: 0;">Good government coordination skills</div>
                                <p style="line-height: normal;font-size: 18px;">We maintain long-term and good communication and coordination channels with the Ministry of Commerce, national convention and exhibition industry associations, convention and exhibition authorities and industry associations across the country.</p>
                            </div>
                        </li>
                        <li>
                            <img src="../images/img-7.png" alt="">
                            <div style="text-align: center;box-sizing: border-box;padding: 0 70px;justify-content: unset;padding-top: 110px">
                                <div style="line-height: normal;text-align: center;padding-left: 0;margin-left: 0;">Harmonious venue cooperation atmosphere</div>
                                <p style="line-height: normal;font-size: 18px;">We have established long-term and efficient cooperative relationships with exhibition venues in Beijing, Shanghai, Tianjin, Chongqing, Guangzhou, Shenzhen, Chengdu, Wuhan, Nanjing, Changsha, Hefei and other places.</p>
                            </div>
                        </li>
                    </ul>
                </section>
                <section class="col" style="padding-top: 50px; padding-bottom: 50px;">
                    <h4 class="title3" style="margin-bottom: 30px;color: #333333;font-size: 30px;">Full Process Digital Services</h4>
                    <div class="">
                        <ul class="list4">
                            <li>
                                <div class="i-title" style="margin-bottom: 28px;">
                                    <img src="../images/icon-1.svg" alt="" style="width: 33px;height: 33px;">
                                    <span style="font-size: 21px;">Newspaper Function</span>
                                </div>
                                <p style="text-align: left;font-size: 18px;">Exhibitors can submit pavilion application materials online through the self-developed pavilion application system on the computer terminal, and HKCEC Cloud will provide online drawing review service to help exhibitors quickly complete the pavilion application process.</p>
                            </li>
                            <li>
                                <div class="i-title" style="margin-bottom: 28px;">
                                    <img src="../images/icon-2.svg" alt="" style="width: 33px;height: 33px;">
                                    <span style="font-size: 21px;">Inquiry Function</span>
                                </div>
                                <p style="text-align: left;font-size: 18px;">You can enter the query interface of the registration system through the PC, and the main venue cloud uniformly assigns the query code, which is convenient for the organizer of the exhibition to understand the registration situation in real time.</p>
                            </li>
                            <li>
                                <div class="i-title" style="margin-bottom: 28px;">
                                    <img src="../images/icon-3.svg" alt="" style="width: 33px;height: 33px;">
                                    <span style="font-size: 21px;">On-site ordering</span>
                                </div>
                                <p style="text-align: left;font-size: 18px;">You can directly purchase related goods on the exhibition site through the mobile app, realizing contactless service, combining high efficiency, convenience and speed.</p>
                            </li>
                        </ul>
                    </div>
                </section>
                <section class="col box-3">
                    <h4 class="title3" style="margin-bottom: 50px;color: #333333;font-size: 30px;">Business partner</h4>
                    <ul class="brand-list">
                        <li><img src="../images/brand-1.svg" alt=""></li>
                        <li><img src="../images/brand-2.svg" alt=""></li>
                        <li><img src="../images/brand-3.svg" alt=""></li>
                        <li><img src="../images/brand-4.svg" alt=""></li>
                        <li><img src="../images/brand-5.svg" alt=""></li>
                        <li><img src="../images/brand-6.svg" alt=""></li>
                        <li><img src="../images/brand-7.svg" alt=""></li>
                        <li><img src="../images/brand-8.svg" alt=""></li>
                        <li><img src="../images/brand-9.svg" alt=""></li>
                        <li><img src="../images/brand-10.svg" alt=""></li>
                        <li><img src="../images/brand-11.svg" alt=""></li>
                        <li><img src="../images/brand-12.svg" alt=""></li>
                    </ul>
                </section>

                
            </div>
            <div class="box-fwlx">
                <section class="col box-3 ">
                    <div class="box-fwlx-con-2">
                        <p>Mr. Gu</p>
                        <img src="../images/img-kf3.png" alt="">
                        <p>contact details</p>
                        <span>010-814401164-801</span>
                    </div>
                </section>
            </div>
        </div>
        <!-- 尾部 -->
      <footers></footers>
      <!-- 右侧吸附客服咨询按钮 -->
      <contact></contact>
    </div>
</template>
    <script>
        import headers from '@/common/header';
    import footers from '@/common/Footer';
    import contact from '@/components/contact';
    export default {
        components: {
            headers,
            footers,
            contact
        },
        data(){
            return {
                langluageType:sessionStorage.getItem('langluageType')||'ch',
            }
        }
    }
            
    </script>


// WEBPACK FOOTER //
// src/page/index.vue